module.exports = __webpack_public_path__ + "img/free-seo-tool.34e81f5b.png";